/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserSaveModel } from '../../models/user-save-model';

export interface UserPost$Json$Params {
      body?: UserSaveModel
}

export function userPost$Json(http: HttpClient, rootUrl: string, params?: UserPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, userPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<string>;
    })
  );
}

userPost$Json.PATH = '/User';
